module.exports = "<light-core-ajax src=\"{{src}}\" data=\"{{params}}\" method=\"post\" content-type=\"application/x-www-form-urlencoded\" on-success=\"_onSuccess\" on-error=\"_onError\" class=\"u-hide\"></light-core-ajax>\n";
